import {
  DATE_FORMAT_ISO_FNS,
  DATE_FORMAT_LONG_FNS,
  DATE_FORMAT_LONG_MINUTE_FNS,
} from 'CorePackage/MainModule/constants/dateFormats';
import { formatDate } from 'CorePackage/MainModule/common/formatDate';

export const convertFormDateTimeValueToKnmDataDate = (
  dateString?: string | null,
  isLongFormat?: boolean,
): string | null => {
  if (dateString) {
    return formatDate({
      date: dateString,
      dateFormat: DATE_FORMAT_ISO_FNS,
      parseFormat: isLongFormat ? DATE_FORMAT_LONG_FNS : DATE_FORMAT_LONG_MINUTE_FNS,
    });
  }

  return null;
};
